import React from 'react';
import { Outlet, useParams, Link, useLocation } from 'react-router-dom';
import Breadcrums from '../../common/breadcrumbs';
import { useTranslation } from "react-i18next";
const RestaurantView = (props) => {
    const {t} = useTranslation();
    const params = useParams();
    const loc = useLocation();

    const breadcrumbs = [
        { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard" },
        {
          title:  t("admin.cafes.link_cafes"),
          url: "/admin/cafe-management/cafe/list/1",
        },
        { title: t("admin.cafes.link_view"), url: "" },
      ];
    



    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                {/* <h6 className="main-content-label">{eventTitle}</h6> */}
                                <div className="">
                                    <h6 className="main-content-label mb-3">
                                        {t("admin.cafes.view_heading")}
                                    </h6>
                                </div>
                            </div>
                            <div className="tabs-wrap">
                                <div className="profile-tab tab-menu-heading mb-4">
                                    <nav className="nav main-nav-line p-3 tabs-menu profile-nav-line bg-gray-100">

                                        <Link to={`/admin/cafe-management/cafe/view/${params?.id}/generals`}
                                        className={"nav-link linkactive" + (loc.pathname.includes(`/admin/cafe-management/cafe/view/${params?.id}/generals`) ? " active" : "")}>
                                            {t("admin.cafes.title_generals")}
                                        </Link>
                                        <Link to={`/admin/cafe-management/cafe/view/${params?.id}/enroll-cafe/details/1`} 
                                        className={"nav-link linkactive" + (loc.pathname.includes(`/admin/cafe-management/cafe/view/${params?.id}/enroll-cafe`) ? " active" : "")}>
                                            {t("admin.cafes.title_enrollments")}
                                        </Link>
                                       
                                    </nav>
                                </div>
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RestaurantView;